import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Vuex)

// var URL = 'http://localhost:5072/'
// var URL = 'http://36.88.33.75:5043/'
var URL = 'https://server-sikonpak.konaweselatankab.go.id/'

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : true,
      edit : true,
      remove : true,
    },
    url : {
      URL_APP : URL,
      checkAuth : URL + 'api/v1/checkAuth/',
      URL_DM_REGISTER : URL+'api/v1/dm_registrasi/',
      URL_DM_MENU : URL+'api/v1/dm_menuList/',
      URL_DM_KLP_USERS : URL+'api/v1/dm_kelompokUsers/',
      URL_DM_STATUS_PERKAWINAN : URL+'api/v1/dm_perkawinan/',
      URL_DM_BIDANG : URL+'api/v1/master_bidang/',
      URL_DM_KECAMATAN : URL + 'api/v1/m_kecamatan/',
      URL_DM_DES_KEL : URL + 'api/v1/m_des_kel/',
      URL_DASHBOARD : URL + 'api/v1/dashboard/',
      URL_UNIT_KERJA : URL + 'api/v1/unit_kerja/',

      URL_tahun : URL+'api/v1/dm_tahun/',
      URL_PRO_KEG : URL+'api/v1/program_kegiatan/',
      URL_PAJAK : URL+'api/v1/laporan_pajak/',
      URL_KON : URL+'api/v1/konsultasi/',
      URL_SOS : URL+'api/v1/sosialisasi/',
      URL_BUKU : URL+'api/v1/buku_pajak/',
    },

    list_tahun : [2021,2022,2023,2024,2025,2026],

    list_contoh_autocomplete : [],
    list_status_perkawinan : [],
    list_agama : [],
    list_bahasa : [],
    list_des_kel : [],
    list_upah : [],
    list_pendidikan : [],
    list_jurusan : [],
    list_keterampilan : [],
    list_bidang : [],
    
    list_menu : null,
    aksesMenu : {},

    list_kecamatan: [],
    list_desa: [],

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    type : [
      {id : 0, uraian : 'Single Menu'},
      {id : 1, uraian : 'Multy Menu'}
    ],

    
  },
  mutations: {
    listJeniskategorilokasi(state){

      fetch(state.url.URL_MasterKategoriLokasi, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          state.list_MasterKategoriLokasi = res_data;
      });

    },

    listApelJenis(state){

      fetch(state.url.URL_apelJenis, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data)
          state.list_ApleJenis = res_data;
      });

    },

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'red',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
